export default function TokenLogo(props) {
  const { width, height } = props;
  return (
    <div className="token-logo" style={{ width: width || "30px", height: height || "30px" }}>
      {props.children}
    </div>
  );
}
